import { render } from "./ModuleInscriptionAction.vue?vue&type=template&id=5facebb0&scoped=true"
import script from "./ModuleInscriptionAction.vue?vue&type=script&lang=js"
export * from "./ModuleInscriptionAction.vue?vue&type=script&lang=js"

import "./ModuleInscriptionAction.vue?vue&type=style&index=0&id=5facebb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5facebb0"]])

export default __exports__